import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Chart from "react-apexcharts";
import { Padding } from '@mui/icons-material';
import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import './../../../../cssfiles/homepage.css';
import pointer from '../../../../images/pointer.png';
import Typography from '@mui/material/Typography';
import { useState, useEffect } from "react";

const Linearprogressbarsimplie = (props) => {
const historicaldata = useSelector((state) => state.mainpagedata.historicaldata);

  const theme = useSelector((state) => state.themedata.theme)
  const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
  //console.log("inside linearprogress chart**********************tagcollectionvalue********************", tagcollectionvalue);
  const [options, setOptions] = useState(0);
  const [leftAlignment, setleftAlignment] = useState();
  const [valuepf, setValuePF] = useState(0)
  const [time, setTime] = useState("01-01-1970 00:00:00")
  const livedata = useSelector((state) => state.mainpagedata.livedata);

  var seriesprogress2= [
    {
      name: "Process 3",
      color:"#00943D",
      data: [23]
    },
    {
      name: "Process 4",
      color:"#DC272D",
      data: [212]
    },
    {
      name: "Process 5",
      color:"#00943D",
      data: [23]
    }
  ];
  var optionsProgress2 = {
      chart: {
          type: "bar",
          stacked: true,
          sparkline: {
              enabled: true
          },
      },
    grid:{
        show:false,    
    },
    plotOptions: {
        bar: {
            horizontal: true,
            barHeight: "50%",
            barWidth: "100%",
            /*colors: {
              backgroundBarColors: ["#00943D"]
              colors: ["#00943D","#DC272D","#00943D"],
            } */
        }
    },
    stroke: {
        width: 0
    },
    tooltip: {
        enabled: false
    },
    xaxis: {
    },
    yaxis: {
      show:true,
    },
  };

    // useEffect(() => {
    //     for(let i=0; i<historicaldata.length; i++) {
    //         if(props.widgetprop.props.extended.tagprops[0].tagid === historicaldata[i].tagid) {
    //             var sum = 0
    //             var count = 0
    //             for(let j=0; j<historicaldata[i].histdata.length; j++) {
    //                 if(historicaldata[i].histdata[j].value > 0) {
    //                     sum = sum + historicaldata[i].histdata[j].value
    //                     count = count + 1
    //                 }
    //             }
    //             var avg = []
    //             avg.push((sum / count).toFixed(2))
    //             //setSerice(avg)
    //             if(sum != 0) {
    //                 setOptions((sum / count).toFixed(2))
    //                 setleftAlignment((sum / count).toFixed(2) * 410)
    //             } else {
    //                 setOptions(0.00)
    //                 setleftAlignment(0)
    //             }
    //             //console.log("PF ",avg, historicaldata[i].histdata)
    //         }
    //     }
    // },[historicaldata])

    useEffect(() => {
      if(livedata.length) {
          for(let i=0; i<livedata.length; i++) {
              //console.log("value card ",livedata[i].TagId, props.widgetprop.props.extended.tagprops[0].tagid)
              if(parseInt(props.widgetprop.props.extended.tagprops[0].tagid) === parseInt(livedata[i].TagId)) {
                  //console.log("livedata[i].value ",livedata[i].value)
                  setValuePF(livedata[i].value.toFixed(3))
                  var date = new Date(livedata[i].timestamp * 1000)
                  var month = date.getMonth()+1;
                  var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (month > 9 ? month : "0"+ month) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                  setTime(timestamp)
              }
          }
      }
  },[livedata])

  return (
    <>
    <Typography sx={{fontFamily:"Roboto",fontSize:"58px",fontWeight:400,alignItems:"center",marginTop:"20px",color:theme=='dark'?"white":"black"}}>{valuepf}</Typography>
    <Stack spacing={2} sx={{ flexGrow: 1,paddingTop:0,paddingLeft:2 }}>
      {/* <BorderLinearProgress variant="determinate" value={50} /> */}
      
      <div style={{position:'relative'}}>
          <div style={{position:'absolute',top:"7px", left:(valuepf==0)?("210px"):((valuepf>=0)?(203+(valuepf*100*2.024)+""+"px"):(203-(Math.abs(valuepf)*100*2.024)+""+"px"))}}><img src={pointer} alt="Smartcomm Logo" /></div>
      </div>
      <Chart options={optionsProgress2} series={seriesprogress2} type='bar' height="15%" width="114%" />
      <div style={{display:'flex',flexDirection:"row",height:"15%",width:"97%"}}>
            <Typography sx={{fontFamily:"Roboto",fontSize:"15px",fontWeight:400,marginLeft:"5px",alignItems:"center",color:theme=='dark'?"white":"black"}}>{"Lead"}</Typography>
            <div style={{flexGrow: 1}}></div>
            <Typography sx={{fontFamily:"Roboto",fontSize:"15px",fontWeight:400,alignItems:"center",color:theme=='dark'?"white":"black"}}>{"Lag"}</Typography>
      </div>
      <Typography sx={{fontFamily:"Roboto",fontSize:"18px",fontWeight:400,alignItems:"center",color:theme=='dark'?"white":"black"}}>{time}</Typography>
      
    </Stack>
    {/*
    <div style={{display:"flex",flexDirection:"row",marginleft:"10px",marginTop:"40px",alignItems:"baseline"}}>
          <Typography sx={{paddingLeft:"10px",fontSize:"14px",fontWeight:400,fontFamily:"Roboto",color:theme=='dark'?"white":"black"}}>Estimated Surcharge (INR)</Typography>
          <Typography sx={{fontSize:"24px",fontWeight:400,fontFamily:"Roboto",color:theme=='dark'?"white":"black",marginLeft:"190px",}}>240/-</Typography>
    </div>*/}
    </>
  );
};

export default Linearprogressbarsimplie;
